import { RemoveTagEvent } from '@progress/kendo-angular-dropdowns';
import { IFieldDefinitionLogic } from '../../interfaces/ifield-definition-logic.interface';
import { IViewModel } from '../../interfaces/view-model.interface';
import { FieldDefinitionService } from '../../services/field-definition.service';
import { FormField } from '../form-builder/form-field.model';
import { FormInstanceElement } from '../form-builder/form-instance-element.model';
import { CustomDateFormatDirective } from '../../directives/custom-date-format.directive';

export class FormInstanceGridRow implements IViewModel {
    // meta data
    public id: number;

    //VNEXT-1099 - KLW: Adding fields to Site Homepage
    public createdBy: string;
    public createdByDisplayName: string; // Added 06-05-2024
    public createdDate: Date;
    public modifiedBy: string;
    public modifiedByDisplayName: string; // Added 06-05-2024
    public modifiedDate: Date;

    public name: string;
    public formTemplateName: string;
    public linkedFormInstance: boolean;
    // chose to name this favorite instead of isFavorite (same in server view model)
    // to keep the display of the Home Page Grid column name simple and not require aliasing
    // (The favorite column being a special case)
    public favorite: boolean;
    public isReference: boolean;
    public isReferenced: boolean;
    public dataCollectionId: number;
    public folderId: number;
    public folderName: string;
    public folderPath: string;
    public workflowState: string;
    public workflowName: string;
    public isFirstGridRow: boolean;

    // pharvey - added for VNEXT-983 - home page actions
    public canMoveFormInstance: boolean;
    public canCopyFormInstance: boolean;
    public canDeleteFormInstance: boolean;
    public canRenameForm: boolean;
    public canCreateFolder: number;
    public canDeleteFolder: number;
    public canCreateForm: number;
    public canDeleteForm: number;

    public rowData: FormInstanceElement[];
    private static columnDefinitions: FormField[];

    //VNEXT-1099 - KLW: Used for custom date format strings
    //private getMetaDataValuePropertyNames_DateFormatting: string[] = ["createdDate", "modifiedDate"];

    public static getSimpleFormsGridValues(fiGridRow: FormInstanceGridRow, columnDefinitions: FormField[]): object {
        FormInstanceGridRow.columnDefinitions = columnDefinitions;
        let obj = {};
        for (let column of columnDefinitions) {
            obj[column.name.toLowerCase()] = fiGridRow[column.name.toLowerCase()];
        }
        obj['canCopy'] = fiGridRow.canCopyFormInstance;
        obj['canMove'] = fiGridRow.canMoveFormInstance;
        obj['canDelete'] = fiGridRow.canDeleteFormInstance;
        obj['canRename'] = fiGridRow.canRenameForm;
        obj['isFirstGridRow'] = fiGridRow.isFirstGridRow;
        obj['id'] = fiGridRow.id;
        // PJH - 4/2/2026 - added for VNEXT-1749 to enable links in Forms Grid for downloading attachments
        obj['standard_attachment_id_column'] = fiGridRow['standard_attachment_id_column'];

        return obj;
    }
}
